// extracted by mini-css-extract-plugin
export var gif = "_jq-0";